import { api } from './api';

// ==================== DTOs ====================

export interface ConversationDto {
  id: string;
  userId: string;
  title: string;
  startedAt: string;
  lastMessageAt: string;
  messageCount: number;
  isActive: boolean;
  createdAt: string;
}

export interface ConversationDetailDto extends ConversationDto {
  messages: MessageDto[];
}

export interface MessageDto {
  id: string;
  conversationId: string;
  role: 'User' | 'Coach';
  content: string;
  tokensUsed: number;
  contextSummary?: string;
  createdAt: string;
}

export interface CheckInNotificationDto {
  id: string;
  type: string;
  message: string;
  createdAt: string;
  isRead: boolean;
}

// ==================== Request Types ====================

export interface SendCoachMessageRequest {
  content: string;
  conversationId?: string;
}

// ==================== Service ====================

export const coachService = {
  /**
   * Send a message to the AI Creative Coach.
   */
  async sendMessage(request: SendCoachMessageRequest): Promise<ConversationDetailDto> {
    return api.post<ConversationDetailDto>('/coach/messages', request);
  },

  /**
   * Get all conversations for the current user.
   */
  async getConversations(): Promise<ConversationDto[]> {
    return api.get<ConversationDto[]>('/coach/conversations');
  },

  /**
   * Get a specific conversation with messages.
   */
  async getConversation(id: string): Promise<ConversationDetailDto | null> {
    try {
      return await api.get<ConversationDetailDto>(`/coach/conversations/${id}`);
    } catch {
      return null;
    }
  },

  /**
   * Delete a conversation and all its messages.
   */
  async deleteConversation(id: string): Promise<void> {
    await api.delete(`/coach/conversations/${id}`);
  },
};
